import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import './assets/css/reset.css'

Vue.config.productionTip = false

// axiosのデフォルトbaseURLを設定
import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT

import http from './plugins/http'
Vue.use(http, router)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VModal from 'vue-js-modal'
Vue.use(VModal)

import UUID from 'vue-uuid'
Vue.use(UUID as any)

import Loading from './plugins/loading'
Vue.use(Loading)

import VCalendar from 'v-calendar'
Vue.use(VCalendar)

import Console from './plugins/Console'
Vue.use(Console)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('fa-icon', FontAwesomeIcon)

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

import BaseLayout from './layouts/BaseLayout.vue'
Vue.component('base-layout', BaseLayout)
import NoneLayout from './layouts/NoneLayout.vue'
Vue.component('none-layout', NoneLayout)
import StudentAuthedLayout from './layouts/StudentAuthedLayout.vue'
Vue.component('student-authed-layout', StudentAuthedLayout)
import AdminAuthedLayout from './layouts/AdminAuthedLayout.vue'
Vue.component('admin-authed-layout', AdminAuthedLayout)
import BranchAuthedLayout from './layouts/BranchAuthedLayout.vue'
Vue.component('branch-authed-layout', BranchAuthedLayout)
import StudyLayout from './layouts/StudyLayout.vue'
Vue.component('study-layout', StudyLayout)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
